<app-shared-dialog
  [title]="'knowledge_base.price_observations.remember_reference.title' | translate"
  [options]="{
    size: 'medium',
    hideCloseButton: true,
    middleText: 'knowledge_base.price_observations.remember_reference.decline' | translate,
    middleButtonStyle: 'secondary',
    confirmText: 'knowledge_base.price_observations.remember_reference.confirm' | translate
  }"
  (middle)="correctOnly()"
  (confirm)="remember()"
>
  <div class="remember-reference">
    <p class="remember-reference__question">
      {{
        "knowledge_base.price_observations.remember_reference.body"
          | translate: { code: data.code, customer: data.customerName, product: data.productLabel }
      }}
    </p>
    <p class="remember-reference__note">
      {{ "knowledge_base.price_observations.remember_reference.note" | translate }}
    </p>
  </div>
</app-shared-dialog>
